export interface ConsultingTeamMember {
  id?: string;
  consultingOrganizationId: string;
  firstName: string;
  lastName: string;
  email: string;
  dateCreated?: Date;
  lastModified?: Date;
}

export enum ConsultingTeamMemberRole {
  EXECUTIVE = 'EXECUTIVE',
  CLIENT_MANAGER = 'CLIENT_MANAGER',
  SUPERVISOR = 'SUPERVISOR',
  ONSITE_PROVIDER = 'ONSITE_PROVIDER',
}

export interface ConsultingTeamMemberAssignment {
  id?: string;
  teamMemberId: string;
  consultingOrganizationId: string;
  enterpriseId?: string;
  facilityId?: string;
  role: ConsultingTeamMemberRole;
  dateCreated?: Date;
  lastModified?: Date;
}
